import { $Q, $Qll } from '../utils/querySelector';
import axios from 'axios';
import { createMessage } from './message';
import { autocomplete } from './autocomplete';

const PRODUCT_REGISTRATION_API =
  'https://product-registration-gr.herokuapp.com';

// const PRODUCT_REGISTRATION_API = 'http://localhost:3000';
const PRODUCT_ERRORS = {
  ALREADY_REGISTERED: 'ALREADY_REGISTERED',
  COULD_NOT_BE_SAVED: 'NOT_SAVED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  EMPTY_FIELDS: 'EMPTY_FIELDS',
  NOT_FOUND: 'NOT_FOUND',
};

/**
 *
 * returns a list of products with title and id, given a title entered by the
 * user
 *
 * @param {string} title name of the product to query
 * @returns {Promise<Array<object>>}
 */
const searchProducts = async (title) => {
  const { data } = await axios.post(
    `${PRODUCT_REGISTRATION_API}/product/search`,
    {},
    {
      params: {
        title,
      },
    }
  );

  return data;
};

const productPlace = () => {
  const select = $Q('#selectProductPlace');
  const input = $Q('#otherPlace');
  let result = select.options[select.selectedIndex].value;

  if (select) {
    if (result === 'other-camp') {
      result = input.value;
    }
    return result;
  }
};

const showDeleteProductModal = (e) => {
  const row = e.target.closest('[role="row"]');
  const productName = $Q('[headers="ColumnName"]', row).textContent;
  const serial = row.dataset.serial;

  const modalParagraph = $Q('.modal-delete-rp__text');
  modalParagraph.textContent = modalParagraph.dataset.text.replace(
    '{{ product }}',
    productName
  );

  const modalConfirm = $Q('.modal-delete-rp__save');
  modalConfirm.dataset.serial = serial;

  const modal = $Q('.modal-delete-rp');
  modal.classList.add('active');
};

const deleteRegisteredProduct = async () => {
  const saveButton = $Q('.save-button');
  const customerEmail = saveButton.getAttribute('data-customer-email');
  const productSerial = $Q('.modal-delete-rp__save').dataset.serial;

  await axios.post(`${PRODUCT_REGISTRATION_API}/customer/products/delete`, {
    customerEmail,
    productSerial,
  });

  const row = $Q(`[role="row"][data-serial="${productSerial}"]`);
  row.remove();

  const modal = $Q('.modal-delete-rp');
  modal.classList.remove('active');
};

const getRegisteredProducts = async (customerEmail) => {
  const modal = $Q('.modal-delete-rp');
  const modalClose = $Q('.modal-delete-rp__close');
  modalClose.addEventListener('click', () => {
    modal.classList.remove('active');
  });
  const modalCancel = $Q('.modal-delete-rp__cancel');
  modalCancel.addEventListener('click', () => {
    modal.classList.remove('active');
  });
  const modalConfirm = $Q('.modal-delete-rp__save');
  modalConfirm.addEventListener('click', deleteRegisteredProduct);

  const table = $Q('.registered-products-table');
  try {
    table.classList.add('loading');

    const {
      data: { data: registeredProducts },
    } = await axios.post(`${PRODUCT_REGISTRATION_API}/customer/products`, {
      customerEmail,
    });

    const tableBody = $Q('.registered-products-table__body');
    tableBody.innerHTML = '';
    const exampleRow = $Q('.example-row');
    const fragment = document.createDocumentFragment();

    if (registeredProducts.length > 0) {
      registeredProducts.forEach((item) => {
        const newRow = exampleRow.cloneNode(true);
        const date = new Date(item.purchase_date);
        const place = item.purchase_place === null ? '' : item.purchase_place;

        const formattedDate = `${date.getDate()}/${date.getMonth() + 1
          }/${date.getFullYear()}`;

        newRow.classList.remove('example-row');
        newRow.dataset.serial = item.serial;

        newRow
          .querySelector('[headers="ColumnName"]')
          .appendChild(document.createTextNode(item.product_name));

        newRow
          .querySelector('[headers="ColumnSerialNumber"]')
          .appendChild(document.createTextNode(item.serial));

        newRow
          .querySelector('[headers="ColumnPurchaseDate"]')
          .appendChild(document.createTextNode(formattedDate));

        newRow
          .querySelector('[headers="ColumnPurchasePlace"]')
          .appendChild(document.createTextNode(place));

        fragment.appendChild(newRow);
      });

      tableBody.appendChild(fragment);
      const buttons = $Qll('.product-registration__remove', tableBody);
      if (buttons) {
        [...buttons].forEach((button) => {
          button.addEventListener('click', showDeleteProductModal);
        });
      }
    } else {
      // show message of empty products
      const messageContainer = document.createElement('div');
      messageContainer.classList.add('registered-products-table__message');
      messageContainer.appendChild(
        document.createTextNode(table.dataset.emptyMessage)
      );
      table.appendChild(messageContainer);
    }
  } catch (e) {
    // show error message
    if (!table.querySelector('.registered-products-table__message')) {
      const messageContainer = document.createElement('div');
      messageContainer.classList.add('registered-products-table__message');
      messageContainer.appendChild(
        document.createTextNode(table.dataset.errorMessage)
      );
      table.appendChild(messageContainer);
    }
  } finally {
    table.classList.remove('loading');
  }
};

/**
 * Setup registration date input's min and max attributes
 */
const setupRegistrationDateInput = () => {
  /**
   *
   * @param {Date} date - date to format
   */
  const formatDate = (date) => {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    return `${year}-${month >= 10 ? month : `0${month}`}-${day >= 10 ? day : `0${day}`
      }`;
  };

  const today = new Date();
  const maxValue = formatDate(today);

  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 3);
  const minValue = formatDate(minDate);

  const input = $Q('input[name="purchase_date"]');

  input.setAttribute('max', maxValue);
  input.setAttribute('min', minValue);
};

/**
 *
 * @param {Date} date - date to validate
 */
const validateDateFromInput = (date) => {
  // remove one day, since for some reason it subtracts one day due to timezone issues
  // date.setDate(date.getDate() + 1);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);

  const today = new Date();

  if (date >= today) {
    return false;
  }

  const last3YearsDate = new Date();
  last3YearsDate.setFullYear(today.getFullYear() - 3);

  if (date < last3YearsDate) {
    return false;
  }

  return true;
};

/**
 * Validate some cases of place select
 * @param {InputField} Other input field
 * @param {SelectField} Select place field
 * @returns
 */
const validateSelectPlace = (otherFieldPlace, selectPlace) => {
  const optionSelected = selectPlace.options[selectPlace.selectedIndex];
  if (
    optionSelected.classList.contains('other-camp') &&
    !otherFieldPlace.value
  ) {
    return false;
  }
  return true;
};

if (document.body.dataset.template === 'page.account.product-registration') {
  document.addEventListener('DOMContentLoaded', async () => {
    // setup registration date min and max attributes
    setupRegistrationDateInput();

    // configure autocomplete for product name input
    autocomplete('#productName', {
      debounce: 1500,
      events: {
        onType: async (value) => {
          if (!value) {
            return [];
          }

          const products = await searchProducts(value);

          return products.map((product) => ({
            label: product.title,
            data: {
              id: product.id,
              collections: product.collections,
            },
          }));
        },
      },
    });

    // consume api to show registered products for current customer
    const saveButton = $Q('.save-button');
    const customerEmail = saveButton.getAttribute('data-customer-email');

    getRegisteredProducts(customerEmail);

    allowOtherProduct();

    // bind click event to save button
    saveButton.addEventListener('click', async (e) => {
      // get values
      const productName = $Q('#productName');
      const serialNumber = $Q('#serialNumber');

      const purchaseDate = $Q('#purchaseDate');

      const selectPlace = $Q('#selectProductPlace');
      const otherFieldPlace = $Q('#otherPlace');

      const messageContainer = $Q('#message-container');

      const purchasePlace = productPlace();

      if (!(productName.value && serialNumber.value && purchaseDate.value)) {
        createMessage({
          message: messageContainer.dataset.emptyFieldsMessage,
          messageType: 'error',
          mountOn: messageContainer,
          timeout: 4000,
        });
        return;
      }

      const errorMessages = {
        [PRODUCT_ERRORS.ALREADY_REGISTERED]:
          messageContainer.dataset.alreadyRegisteredMessage,
        [PRODUCT_ERRORS.EMPTY_FIELDS]:
          messageContainer.dataset.emptyFieldsMessage,
        [PRODUCT_ERRORS.COULD_NOT_BE_SAVED]:
          messageContainer.dataset.notSavedMessage,
        [PRODUCT_ERRORS.INTERNAL_ERROR]: messageContainer.dataset.errorMessage,
        [PRODUCT_ERRORS.NOT_FOUND]: messageContainer.dataset.notFoundMessage,
      };

      if (!validateDateFromInput(purchaseDate.valueAsDate)) {
        createMessage({
          message: messageContainer.dataset.invalidDate,
          messageType: 'error',
          mountOn: messageContainer,
          timeout: 5000,
        });

        return;
      }

      if (!validateSelectPlace(otherFieldPlace, selectPlace)) {
        createMessage({
          message: messageContainer.dataset.invalidOther,
          messageType: 'error',
          mountOn: messageContainer,
          timeout: 5000,
        });
        return;
      }

      saveButton.classList.add('loading');

      const productInfo = {
        name: productName.value,
        extra: productName.dataset.extra,
        serial: serialNumber.value,
        purchaseDate: purchaseDate.value,
        purchasePlace: purchasePlace,
        customerEmail,
      };

      try {
        const { data } = await axios.post(
          `${PRODUCT_REGISTRATION_API}/product/register`,
          productInfo
        );

        if (data.success) {
          createMessage({
            message: messageContainer.dataset.successMessage,
            messageType: 'success',
            mountOn: messageContainer,
            timeout: 5000,
          });

          // clear values
          productName.value = '';
          serialNumber.value = '';
          purchaseDate.value = '';
          productName.removeAttribute('data-extra');
          selectPlace.value = '';
          otherFieldPlace.value = '';

          $Q('.registered-products-table__message')?.remove();
          getRegisteredProducts(customerEmail);
        } else {
          createMessage({
            message: errorMessages[data.error],
            messageType: 'error',
            mountOn: messageContainer,
            timeout: 5000,
          });
        }
      } catch (e) {
        // show error message
        createMessage({
          message: errorMessages[e.response.data.error],
          messageType: 'error',
          mountOn: messageContainer,
          timeout: 8000,
        });
      } finally {
        saveButton.classList.remove('loading');
      }
    });
  });
}

const allowOtherProduct = () => {
  const select = $Q('#selectProductPlace');
  const input = $Q('.productinput-place');

  if (select) {
    select.addEventListener('change', () => {
      if ($Q('.other-camp').selected) {
        input.classList.remove('hidden');
        input.required = true;
      } else {
        input.classList.add('hidden');
        input.required = false;
      }
    });
  }
};
